export const getXSRFToken = () => {
  let xsrfToken;
  let xsrfTokenHeader;
  let headers = {};
  if (process.env.NODE_ENV === "development") {
    xsrfTokenHeader = "X-XSRF-TOKEN";
    xsrfToken = "a13688d8-1d22-4238-87ae-630fdb22822ba13688d8-1d22-4238-87ae-630fdb22822ba13688d8-1d22-4238-87ae-630fdb22822ba13688d8-1d22-4238-87ae-630fdb22822b";
    // ALWAYS GET FROM ISW-PORTAL-V2
  } else {
    xsrfToken = window.parent.document.getElementById("csrf-token")
      ? window.parent.document.getElementById("csrf-token").getAttribute("content")
      : "";
    xsrfTokenHeader = window.parent.document.getElementById("csrf-token")
      ? window.parent.document.getElementById("csrf-header").getAttribute("content")
      : "";
  }

  if (xsrfToken && xsrfTokenHeader) {
    headers[xsrfTokenHeader] = xsrfToken;
    return headers;
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/xsrf-token-header.js